/**
 * streamlines add a dynamic value to top.
 * @param {object} param0
 * @param {number|string} param0.$top
 * @returns {string}
 */
const dynTop = ({ $top }) => {
  if ($top === undefined) return "";
  if (typeof $top === "number") return `top: ${$top}px;`;
  return `top: ${$top};`;
};

export default dynTop;
